/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class Kostenanalyse extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
        window.jQuery('[data-toggle="tooltip"]').tooltip()
    }
    _calcwidths(){
        console.log('calcwidth')

        Utils.normalizeAddonWidths('#basedataentry')



    }

    render (){
        const {dataStore} = this.props;
      //  const self = this;
        var z = 200;
        return <div id="kostenanalyse" className="well">
            <h4>{dataStore.title}</h4>
            <hr/>
            <table className="table table-condensed"><tbody>
            {dataStore.rows.map(entry => {
                z--;
                var styles = {zIndex : z};
                return( <tr key={entry.key}>
                    <td data-toggle="tooltip" data-container="body" data-delay="100" data-placement="auto left" data-template={'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'} title={entry.title}>{entry.headline} </td>
                    <td>{entry.getFormattedVal()} </td>
                    <td>{entry.einheit} </td>
                </tr>);
                }
            )}
            </tbody>
            </table>
        </div>;
    }

}

Kostenanalyse.propTypes = {
    dataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Kostenanalyse.js